import Link from 'next/link';

import { useTranslations } from '@keymono/i18n';
import { FormFeedbackSection, LogoKeymono } from '@keymono/design-system';

import { FormLinkCTA } from '../../components/FormLinkCTA';

import { FormContainer } from '../styles';

/**
 * -----------------------------------------------------------------------------
 * This renders a fallback UI on the registration screen when no token is found.
 */
export function NoTokenForRegistration() {
  const t = useTranslations('Registration');
  const tCommon = useTranslations('Common');

  return (
    <FormContainer>
      <div className="form-responsive-wrapper">
        <div>
          <Link
            href="/"
            className="my-8 hidden w-auto sm:inline-flex"
            aria-label={tCommon('logoAriaLabel')}
            title={tCommon('logoAriaLabel')}
          >
            <LogoKeymono />
          </Link>
          <div className="form-header flex">
            <h1 className="grow">{t('title')}</h1>
          </div>
          <FormFeedbackSection
            isFormSubmitting={false}
            type="error"
            message={t('noToken.formFeedback.message')}
            description={t('noToken.formFeedback.description')}
          />
        </div>
        <div>
          <FormLinkCTA
            href="/auth/sign-up"
            title={t('noToken.goSignUpCTA.title')}
            subTitle={t('noToken.goSignUpCTA.subTitle')}
          />
          <FormLinkCTA
            href="/auth/login"
            title={t('loginButtonCTA.title')}
            subTitle={t('loginButtonCTA.subTitle')}
          />
        </div>
      </div>
    </FormContainer>
  );
}
